import {Dispatch, SetStateAction } from "react";
import axios from "axios";
import {API_BASE} from "../utils/api";

export const useElements = (setData: Dispatch<SetStateAction<any[]>>) => {
		const fetchData = async (where?: string, countries?: string[]) => {
			try {
				const response = await axios.post(`${API_BASE}/elements/raw`, {
					headers: {
						'content-type': 'application/json',
					},
					data: {
						where
					}
				});

				setData(response.data);
				return response.data;
			} catch (error) {
				console.error(error);
			}
		};

		// useEffect(() => {
		//
		// 		fetchData();
		//
		// }, []);

		return { fetchData };
}